import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: all 200ms ease-in-out;

  &.disabled {
    cursor: not-allowed !important;
    transition: none !important;
    &:hover {
      transform: none !important;
    }
  }

  &.onTheField {
    &:hover {
      transform: scale(1.1);
    }
  }

  .redCard,
  .substituted {
    position: static;
  }

  .name {
    background-color: black;
    color: white;
    padding: 1px 2px 1px 2px;
    font-size: 10px;
    text-align: center;
    line-height: 11.5px;
    border-radius: 3px;
  }
`;
